import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const Hand = styled.img`
  position: absolute;
  z-index: 2;
  ${'' /* max-height: 150px; */}
  max-width: ${props => props.noMaxWidth ? 'auto' : '70vh'};
  max-height: ${props => props.noMaxHeight ? 'auto' : '30vh'} !important;
  display: ${props => props.hideOnMobile ? 'none' : 'block'};
  top: ${props => props.top ? props.top : 'auto'};
  right: ${props => props.right ? props.right : 'auto'};
  bottom: ${props => props.bottom ? props.bottom : 'auto'};
  left: ${props => props.left ? props.left : 'auto'};
  transform: translate( ${props => props.hCenter ? '-50%' : '0'}, ${props => props.vCenter ? '-50%' : '0'} );
  @media (min-width: ${breakpoints.desktop}) {
    display: ${props => props.onlyOnMobile ? 'none' : 'block'};
    font-size: 48px;
    max-height: inherit;
  }
`;

export default Hand;



// WEBPACK FOOTER //
// ./src/styled-components/Hand.js